import React from 'react';
import type { ReactElement } from 'react';

import { Icon } from '../../../Icon/Icon';
import { useBreadcrumbContext } from '../../Breadcrumb.context';

type BreadcrumbDividerProps = {
    className?: string;
};

export const BreadcrumbDivider = ({ className, ...rest }: BreadcrumbDividerProps): ReactElement => {
    const { size } = useBreadcrumbContext();
    const mergedSize = size === 'small' ? 'medium' : size;
    return (
        <Icon
            name="s-icon-chevron-right-compact"
            color="disabled"
            aria-hidden="true"
            size={mergedSize}
            className={className}
            data-size={mergedSize}
            {...rest}
        />
    );
};
